import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LocationProvider } from './context/LocationContext';
import { PermissionProvider } from './context/PermissionContext';
import ProtectedRoute from './components/ProtectedRoute';
import { PageLoader } from './components/Loader';

// Lazy load components for code splitting
const LoginPage = lazy(() => import('./pages/LoginPage'));
const DashboardLayout = lazy(() => import('./components/DashboardLayout'));
const DashboardHomePage = lazy(() => import('./pages/DashboardHomePage'));
const UsersPage = lazy(() => import('./pages/UsersPage'));
const RolesPage = lazy(() => import('./pages/RolesPage'));
const CustomersPage = lazy(() => import('./pages/CustomersPage'));
const VisitsPage = lazy(() => import('./pages/VisitsPage'));
const SalesmanVisitsPage = lazy(() => import('./pages/SalesmanVisitsPage'));
const EnquiriesPage = lazy(() => import('./pages/EnquiriesPage'));
const EnquiryActivityPage = lazy(() => import('./pages/EnquiryActivityPage'));
const ReportsPage = lazy(() => import('./pages/ReportsPage'));
const TaskManagementPage = lazy(() => import('./pages/TaskManagementPage'));
const MasterDataPage = lazy(() => import('./pages/MasterDataPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const APITestPage = lazy(() => import('./pages/APITestPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <AuthProvider>
      <PermissionProvider>
        <LocationProvider>
          <Router>
            <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Dashboard Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardHomePage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="roles" element={<RolesPage />} />
              <Route path="customers" element={<CustomersPage />} />
              <Route path="visits" element={<VisitsPage />} />
              <Route path="salesman-visits" element={<SalesmanVisitsPage />} />
              <Route path="enquiries" element={<EnquiriesPage />} />
              <Route path="enquiries/:id/activity" element={<EnquiryActivityPage />} />
              <Route path="tasks" element={<TaskManagementPage />} />
              <Route path="master-data" element={<MasterDataPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="api-test" element={<APITestPage />} />
            </Route>

            {/* Default redirects */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* 404 Page */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Router>
      </LocationProvider>
      </PermissionProvider>
    </AuthProvider>
  );
}

export default App;
